/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What does the slash in */5 mean?`)
};

const es_cr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué significa la barra diagonal en */5?`)
};

const de_cr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was bedeutet der Schrägstrich in */5?`)
};

const nl_cr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat betekent de schuine streep in */5?`)
};

const fr_cr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que signifie la barre oblique dans */5 ?`)
};

const it_cr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa significa la barra in */5?`)
};

const pt_br2_cr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que significa a barra em */5?`)
};

const pt_cr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que significa a barra em */5?`)
};

const ja_cr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*/5のスラッシュは何を意味していますか？`)
};

const zh_cr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*/5 中的斜杠是什么意思？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cr_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cr_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cr_faq4_q", locale)
	if (locale === "en") return en_cr_faq4_q(inputs)
	if (locale === "es") return es_cr_faq4_q(inputs)
	if (locale === "de") return de_cr_faq4_q(inputs)
	if (locale === "nl") return nl_cr_faq4_q(inputs)
	if (locale === "fr") return fr_cr_faq4_q(inputs)
	if (locale === "it") return it_cr_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_cr_faq4_q(inputs)
	if (locale === "pt") return pt_cr_faq4_q(inputs)
	if (locale === "ja") return ja_cr_faq4_q(inputs)
	return zh_cr_faq4_q(inputs)
};